'use strict';

require('gwwp-cookie');